import {
  AGENT_STATUS_API,
  STATUS_CHANGE_ACTION_TYPE,
  STATUS_CHANGE_REASON,
} from '@/constants';

/**
 * Status change request always has at least a status
 * and may have an additional context as well as additional properties.
 */
export interface AgentStatusRequest {
  readonly key?: string;
  /** TODO: Should be optional! */
  readonly status: AGENT_STATUS_API;
  readonly expireIn?: number;
  readonly [key: string]: any;
  readonly statusChangeContext?: {
    readonly type: STATUS_CHANGE_ACTION_TYPE;
    readonly reason?: STATUS_CHANGE_REASON;
  };
}

/**
 * Status data can have any number of additional properties.
 * Timestamp properties are managed by server.
 */
export interface AgentStatusResponse {
  readonly agentId: string;
  readonly status: AGENT_STATUS_API;
  readonly expireIn?: number;
  readonly [key: string]: any;
  readonly lastStatusChange?: string;
  readonly lastStatusUpdate?: string;
  readonly statusChangeContext?: {
    readonly type: STATUS_CHANGE_ACTION_TYPE;
    readonly reason?: STATUS_CHANGE_REASON;
  };
}

export const GET_USERS_PROJECTION = [
  'id', 'email', 'multiUserId', 'role', 'data',
];
